<client-reach-menu activeSection="1">
	<ng-container
		*clientReachMenuSection="'1'; desktopType: 'POPUP'; lightBg: true; alwaysUseDesktop: true"
	>
		<warning-template class="flex-auto w-full flex relative flex-col">
			<ng-content select="[image]" ngProjectAs="[image]"></ng-content>
			<ng-content select="[title]" ngProjectAs="[title]"></ng-content>
			<ng-content></ng-content>
			<div class="gap-1 w-full flex flex-row" ngProjectAs="[options]">
				<ng-content select="[options]">
					@if ($showCancel()) {
						<button class="w-full" buttonOutlined (click)="onCancel()">
							{{ $cancelText() }}
						</button>
					}
					<button
						class="w-full"
						buttonFilled
						[flavor]="$mappedConfirmVariant()"
						(click)="onConfirm()"
					>
						{{ $confirmText() }}
					</button>
				</ng-content>
			</div>
		</warning-template>
	</ng-container>
</client-reach-menu>
